var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332.377,
    height: 118.692,
    viewBox: "0 0 332.377 118.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fullLogo",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M118.693,59.347A59.346,59.346,0,1,1,59.347,0a59.346,59.346,0,0,1,59.346,59.346",
    fill: "#fa2539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M85.913,141.853a2.186,2.186,0,0,1-.153.752q-.09.4-.182.8-.184.8-.373,1.592-.379,1.592-.789,3.178c-.548,2.11-1.146,4.208-1.827,6.279s-1.44,4.1-2.314,6.089c-.668,1.52-1.4,3.013-2.213,4.463-4,7.152-10.147,13.414-17.93,15.972l-8.372-5.958c7.619-2.726,14.236-7.79,19.757-13.706,1.5-1.606,2.926-3.279,4.3-5s2.681-3.485,3.952-5.279,2.5-3.622,3.715-5.461q.617-.938,1.228-1.881.305-.471.609-.943l.3-.472a1.522,1.522,0,0,1,.293-.426",
    transform: "translate(-27.82 -76.241)",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M254.561,128.857l-1.707,9.464a69.054,69.054,0,0,0-13.653,1.629,31.166,31.166,0,0,0-1.629,4.732,106.763,106.763,0,0,1,14.507-1.784c-.466,2.87-.854,6.672-1.319,9.542a97.884,97.884,0,0,0-15.05,2.482c-.077,1.009-.233,2.095-.31,3.181,4.888-1.086,10.706-1.4,15.748-1.862l-1.629,9.852a143.951,143.951,0,0,0-26.531,4.81,102.708,102.708,0,0,1,2.327-17.145c1.552-7.369,3.8-15.127,5.973-22.419a99.607,99.607,0,0,1,23.273-2.482",
    transform: "translate(-119.849 -69.247)",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M286.1,150.784c1.445-7.074,3.271-13.541,5.021-20.083a54.712,54.712,0,0,1,13.236-1.9c12.628,0,17.268,6.846,15.519,15.062-2.358,10.878-15.9,24.114-36.666,26.624a137.21,137.21,0,0,1,2.891-19.7m17.648,1.293c2.434-2.13,4.716-4.564,5.249-7.227a5.762,5.762,0,0,0,0-2.282c-.533-3.119-3.8-3.956-7.379-3.956-.989,0-2.13.076-3.119.152-.913,3.5-1.826,7.151-2.586,10.8-.609,2.814-1.141,5.629-1.521,8.368a23.361,23.361,0,0,0,9.357-5.857",
    transform: "translate(-152.216 -69.226)",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M389.566,139.4a16.524,16.524,0,0,0-5.857-1.179c-8.47,0-14.644,7.708-15.911,13.607a7.011,7.011,0,0,0,.237,4.484,5.431,5.431,0,0,0,5.541,3.7c2.454,0,6.016-.944,11.319-3.461l.87,9.6c-6.649,2.989-12.031,4.247-16.306,4.247-10.844,0-14.406-8.1-12.507-17.383,2.137-10.226,13.457-25.013,27.388-25.013a20.2,20.2,0,0,1,7.837,1.573Z",
    transform: "translate(-191.591 -68.792)",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M454.267,128.535h.15c1.658,12.36,3.467,24.8,6.632,36.251-3.316.98-6.858,2.261-10.25,3.316-.3-.98-.527-2.035-.753-3.09L438.515,167.5c-.452.754-.829,1.507-1.206,2.186-3.542.376-7.461.678-11,1.055,3.09-8.893,20.122-34.367,27.961-42.2M448.614,157.4c-.226-2.336-.528-4.748-.6-7.235a82.372,82.372,0,0,0-5.2,8.667Z",
    transform: "translate(-229.127 -69.083)",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M510.644,131.969c8.8-2.7,15.683-3.975,20.8-3.975,8.4,0,12,3.419,10.882,9.541-1.6,9.143-12,19.718-29.126,24.409-.48,2.544-.88,5.168-1.2,7.713-3.6.159-7.2.875-10.8,1.033.56-3.021,1.12-6.122,1.76-9.223,2.16-9.859,4.721-19.877,7.6-29.5Zm20.084,9.461c1.76-2.306.16-3.1-2.561-3.1a51.386,51.386,0,0,0-9.682,1.511c-1.12,3.658-2.08,7.394-2.961,11.131,5.281-1.192,12.963-6.678,15.2-9.541",
    transform: "translate(-269.382 -68.793)",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M614.456,128.738l-1.716,9.514a69.406,69.406,0,0,0-13.726,1.638,31.355,31.355,0,0,0-1.638,4.757,107.478,107.478,0,0,1,14.584-1.794c-.469,2.886-.858,6.707-1.326,9.592a98.374,98.374,0,0,0-15.129,2.5c-.078,1.014-.234,2.105-.312,3.2,4.913-1.092,10.762-1.4,15.831-1.872l-1.638,9.9a144.723,144.723,0,0,0-26.671,4.835,103.27,103.27,0,0,1,2.339-17.235c1.56-7.408,3.821-15.207,6.005-22.538a100.136,100.136,0,0,1,23.4-2.5",
    transform: "translate(-313.193 -69.183)",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M672.056,140.908c-.922-.537-3.38-2.381-6.3-2.3-3.687.077-7.45,1.075-4.993,3.456,2.228,2.074,10.676,2.535,13.672,6.605a7.35,7.35,0,0,1,1,6.145c-1.076,5.146-5.914,10.984-12.443,13.6a27.192,27.192,0,0,1-9.678,1.843,29.607,29.607,0,0,1-9.6-1.69l3.533-10.83a19.638,19.638,0,0,0,8.833,2.535,10.621,10.621,0,0,0,7.3-2.842c1.613-1.459-1.152-2.919-3.917-3.764-6.068-2-12.6-5.53-10.6-13.288,1.767-6.759,10.293-12.75,19.125-12.75a18.126,18.126,0,0,1,10.369,3.226c-2.151,3.149-4.224,6.99-6.3,10.062",
    transform: "translate(-345.978 -68.592)",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M111.895,98.418c1.117-.849,3.444-1,4.637-1.309q6.017-1.586,12.129-2.579c5.586-.907,11.3-1.432,16.8-.146,3.048.712,6.174,2.136,7.933,5.083,2.222,3.723,1.667,8.856.221,13.124-3.876,11.439-13.045,19.428-22.533,24.976a57.768,57.768,0,0,0,13.644,7.476q-4.827,7.453-9.994,14.6a100.317,100.317,0,0,1-21.547-14.8q-1.394,6.56-2.787,13.119L82.862,158c1.718-2.128,3.944-3.6,5.888-5.447,11.793-11.211,15.2-32.216,20.715-47.8.544-1.538,1.14-5.017,2.191-6.124a1.974,1.974,0,0,1,.24-.213m26.445,16.407c2.586-3.5.381-4.885-3.193-5.085-4.008-.223-9.832.962-13.238,1.653-1.723,5.566-3.236,11.269-4.857,16.966,7.355-1.352,18.113-9.182,21.289-13.534",
    transform: "translate(-44.536 -50.315)",
    fill: "#0c0c0c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/fullLogo.99042bbd478519c3569467790fd1629b.svg";
export { ForwardRef as ReactComponent };